<span
    [ngStyle]="{
      '--cpl-pill-length': 6
    }"
    [ngClass]="
    {
        'bg-primary': status === ItemStatusIndicator.TEMPLATE,
        'border-primary': status === ItemStatusIndicator.TEMPLATE,
        'bg-light': status === ItemStatusIndicator.PREVIEW,
        'cpl-border-light': status === ItemStatusIndicator.PREVIEW,
        'bg-info': status === ItemStatusIndicator.PUBLISHED,
        'border-info': status === ItemStatusIndicator.PUBLISHED,
        'bg-dark': status === ItemStatusIndicator.DRAFT || status === ItemStatusIndicator.ARCHIVED || status === ItemStatusIndicator.DELETED,
        'cpl-border-dark': status === ItemStatusIndicator.DRAFT || status === ItemStatusIndicator.ARCHIVED || status === ItemStatusIndicator.DELETED,
        'cpl-pill': useAbbreviation
    }"
    class="badge cpl-pill-border"  [innerHTML]="statusText"
    [ngbTooltip]="title">
</span>
